import { PrimeNGConfig } from 'primeng/api';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatestWith, switchMap } from 'rxjs';

const PRIMENG_TRANSLATION_KEY = 'primeng';

export function primengLocalizationFactory(translocoService: TranslocoService, primengConfig: PrimeNGConfig) {
  return () => {
    translocoService.langChanges$.pipe(
      switchMap((lang) => translocoService.selectTranslateObject(PRIMENG_TRANSLATION_KEY, undefined, lang))
    ).subscribe(obj => {
      primengConfig.setTranslation(obj);
    });
  };
}
